'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _extends = require('@babel/runtime/helpers/extends');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var common = require('@andes/common');
var warning = require('@andes/common/build/utils/warning');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
const LABEL_POSITION_LEFT = 'left';
const LABEL_POSITION_RIGHT = 'right';
const computeLabelPosition = _ref => {
  let {
    inverted,
    labelPosition
  } = _ref;
  if (typeof inverted !== 'undefined') return inverted ? LABEL_POSITION_LEFT : LABEL_POSITION_RIGHT;
  return labelPosition || LABEL_POSITION_RIGHT;
};
var computeLabelPosition$1 = computeLabelPosition;
const WARNING_SPREAD = "Props spreading will be deprecated in a future major version.\nIf you want to pass props to the <Switch> input, please use 'inputProps' prop instead.";
const namespace = 'andes-switch';
const _excluded = ["checked", "className", "defaultChecked", "disabled", "id", "inputProps", "inverted", "label", "labelPosition", "onChange", "srLabel"];
const Switch = /*#__PURE__*/function () {
  const Switch = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        checked,
        className,
        defaultChecked,
        disabled = false,
        id,
        inputProps = {},
        inverted,
        label,
        labelPosition = 'right',
        onChange,
        srLabel
      } = props,
      otherProps = _objectWithoutProperties__default["default"](props, _excluded);
    React.useEffect(() => {
      warning__default["default"](Object.keys(otherProps).length === 0, WARNING_SPREAD);
    }, []);
    const computedLabelPosition = computeLabelPosition$1({
      inverted,
      labelPosition
    });
    const componentId = context.useId(id);
    const handleChange = event => {
      if (typeof onChange === 'function') onChange(event);
    };
    const switchClassNames = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--label-left")]: computedLabelPosition === LABEL_POSITION_LEFT,
      ["".concat(namespace, "--disabled")]: disabled
    });
    const inputAttributes = _objectSpread__default["default"](_objectSpread__default["default"]({}, otherProps), inputProps);
    return /*#__PURE__*/React__default["default"].createElement("label", {
      className: switchClassNames,
      ref: ref
    }, /*#__PURE__*/React__default["default"].createElement("input", _extends__default["default"]({}, inputAttributes, {
      checked: checked,
      className: "".concat(namespace, "__input"),
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: componentId,
      onChange: handleChange,
      type: "checkbox",
      role: "switch"
    })), label && /*#__PURE__*/_jsx__default["default"]("span", {
      "aria-hidden": !!srLabel || undefined,
      className: "".concat(namespace, "__label")
    }, void 0, label), srLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, srLabel));
  });
  Switch.displayName = 'Switch';
  return Switch;
}();
var Switch$1 = Switch;
exports.Switch = Switch$1;
exports["default"] = Switch$1;
